import React from 'react';
import 'flag-icon-css/css/flag-icon.min.css';
import Layout from 'app/layout/Layout';
import 'weather-icons/css/weather-icons.min.css'
import 'scss/global.scss';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import * as Sentry from '@sentry/react';
// Font Awesome icon register:
library.add(faExclamationTriangle);

if (typeof localStorage !== 'undefined') {
    Sentry.init({
        dsn: 'https://d0bf379d37254575968814f8bc874f91@o64878.ingest.us.sentry.io/137722',
        // Remove BrowserTracing integration to disable performance monitoring
        integrations: [
            // new BrowserTracing({
            //     tracesSampleRate: 0.1,
            // }),
        ],
        // Disable Performance Monitoring
        tracesSampleRate: 0,
        // Disable Session Replay
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        // Environment
        environment: process.env.REACT_APP_ENV || 'development',
        // Release version
        release: process.env.REACT_APP_VERSION || '1.0.0',
        // Enable debug mode in development
        debug: process.env.REACT_APP_ENV === 'development',
        // Capture all errors
        beforeSend(event, hint) {
            // Add additional context
            event.tags = {
                ...event.tags,
                component: 'harbakiosk',
                harbor: window.location.pathname.split('/')[1] || 'unknown'
            };

            // Add user context if available
            if (window.harbaLocale) {
                event.user = {
                    ...event.user,
                    locale: window.harbaLocale
                };
            }

            return event;
        },
        // Capture unhandled promise rejections
        attachStacktrace: true,
        // Capture console errors
        logErrors: true,
    });

    // Global error handler for unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        Sentry.captureException(event.reason, {
            tags: {
                errorType: 'unhandled_promise_rejection'
            }
        });
    });

    // Global error handler for uncaught errors
    window.addEventListener('error', (event) => {
        Sentry.captureException(event.error, {
            tags: {
                errorType: 'uncaught_error'
            }
        });
    });
}

class App extends React.Component {
    componentDidCatch(error, errorInfo) {
        // Log React component errors
        Sentry.captureException(error, {
            extra: errorInfo,
            tags: {
                errorType: 'react_component_error'
            }
        });
    }

    render() {
        return (
            <Layout/>
        );
    }
}

export default App;
